import { CanalVenta, CanalVentaForm } from '@models/.';

export function transformToData(saleChannel: CanalVenta | null): CanalVenta | null {
  if (!saleChannel) return null;
  
  return {
    ...saleChannel,
  };
}

export function transformToForm(saleChannel?: CanalVenta): CanalVentaForm | undefined {
  if (!saleChannel) return;
  
  const {
    idCanalVenta: id,
    nombre: name,
    codigo: code,
  } = saleChannel
  
  return {
    id,
    name,
    code,
  };
}

export function transformArrayToForm(saleChannels: CanalVenta[] | null | undefined): CanalVentaForm[] {
  return (saleChannels ?? []).map((saleChannelForm) => (transformToForm(saleChannelForm)) as CanalVentaForm) ?? [];
}